import PropTypes from "prop-types"
import { Link } from "react-router-dom"

const Breadcrumb = ({ title }) => (
  <nav aria-label="Breadcrumb">
    <ol className="text-grey-30 text-14 tablet:overflow-x-hidden my-32 list-none overflow-x-auto whitespace-nowrap font-semibold">
      <li className="inline-flex">
        <Link className="text-black" data-lc="breadcrumb" to="/">
          Home
        </Link>
      </li>
      <li className="inline-flex before:px-4 before:text-black before:content-['/']">
        {title}
      </li>
    </ol>
  </nav>
)

Breadcrumb.propTypes = {
  title: PropTypes.string,
}

export default Breadcrumb
